import { useState, useEffect } from 'react';
import { apiFetch } from '../api';

function NotificationsPanel({ refreshKey }) {
  const [status, setStatus] = useState(null);
  const [prefs, setPrefs] = useState(null);
  const [testTo, setTestTo] = useState('');
  const [testMsg, setTestMsg] = useState('');
  const [testChannel, setTestChannel] = useState('sms');
  const [sending, setSending] = useState(false);
  const [sendResult, setSendResult] = useState(null);
  useEffect(() => {
    apiFetch('/api/notifications/status').then(r => r.json()).then(setStatus).catch(() => {});
    apiFetch('/api/notifications/preferences').then(r => r.json()).then(setPrefs).catch(() => {});
  }, [refreshKey]);

  async function handleSendTest(e) {
    e.preventDefault();
    setSending(true);
    setSendResult(null);
    try {
      const res = await apiFetch('/api/notifications/test', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to: testTo, message: testMsg, channel: testChannel }),
      });
      const data = await res.json();
      setSendResult(data.success ? 'Sent!' : `Failed: ${data.error || 'Unknown error'}`);
      if (data.success) setTimeout(() => setSendResult(null), 3000);
    } catch (err) {
      setSendResult(`Error: ${err.message}`);
    } finally {
      setSending(false);
    }
  }

  async function handleSavePrefs(newPrefs) {
    try {
      await apiFetch('/api/notifications/preferences', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newPrefs),
      });
      setPrefs(newPrefs);
    } catch {}
  }

  function togglePref(key) {
    const updated = { ...prefs, [key]: !prefs[key] };
    handleSavePrefs(updated);
  }

  if (!status) return <section className="card"><h2>Notifications</h2><p>Loading...</p></section>;

  return (
    <section className="card">
      <h2>Text Notifications</h2>

      {!status.configured && (
        <p style={{ color: '#f87171' }}>Twilio not configured. Add credentials in appsettings.json.</p>
      )}

      {status.configured && prefs && (
        <div className="notif-settings">
          <div className="notif-toggle-row">
            <label className="settings-toggle-label">
              <input type="checkbox" checked={prefs.enabled} onChange={() => togglePref('enabled')} />
              <span>Enable notifications</span>
            </label>
          </div>

          {prefs.enabled && (
            <>
              <div className="notif-toggle-row">
                <label className="settings-toggle-label">
                  <input type="checkbox" checked={prefs.airbnbAlerts} onChange={() => togglePref('airbnbAlerts')} />
                  <span>Airbnb check-in/check-out alerts (8 AM)</span>
                </label>
              </div>
              <div className="notif-toggle-row">
                <label className="settings-toggle-label">
                  <input type="checkbox" checked={prefs.goalReminders} onChange={() => togglePref('goalReminders')} />
                  <span>Daily goal reminders</span>
                </label>
                {prefs.goalReminders && (
                  <select
                    value={prefs.goalReminderHour || 8}
                    onChange={(e) => handleSavePrefs({ ...prefs, goalReminderHour: parseInt(e.target.value) })}
                    style={{ marginLeft: 28, marginTop: 4, background: '#1a1b23', color: '#e4e4e7', border: '1px solid #3a3b45', borderRadius: 6, padding: '4px 8px', fontSize: 13 }}
                  >
                    {Array.from({ length: 24 }, (_, i) => (
                      <option key={i} value={i}>
                        {i === 0 ? '12 AM' : i < 12 ? `${i} AM` : i === 12 ? '12 PM' : `${i - 12} PM`}
                      </option>
                    ))}
                  </select>
                )}
              </div>
              <div className="notif-toggle-row">
                <label className="settings-toggle-label">
                  <input type="checkbox" checked={prefs.medicationReminders} onChange={() => togglePref('medicationReminders')} />
                  <span>Medication reminders if not completed</span>
                </label>
                {prefs.medicationReminders && (
                  <select
                    value={prefs.medicationReminderHour || 14}
                    onChange={(e) => handleSavePrefs({ ...prefs, medicationReminderHour: parseInt(e.target.value) })}
                    style={{ marginLeft: 28, marginTop: 4, background: '#1a1b23', color: '#e4e4e7', border: '1px solid #3a3b45', borderRadius: 6, padding: '4px 8px', fontSize: 13 }}
                  >
                    {Array.from({ length: 24 }, (_, i) => (
                      <option key={i} value={i}>
                        {i === 0 ? '12 AM' : i < 12 ? `${i} AM` : i === 12 ? '12 PM' : `${i - 12} PM`}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              <div className="notif-toggle-row">
                <label className="settings-toggle-label">
                  <input type="checkbox" checked={prefs.weeklySpendingDigest} onChange={() => togglePref('weeklySpendingDigest')} />
                  <span>Weekly spending digest (Mondays)</span>
                </label>
                {prefs.weeklySpendingDigest && (
                  <select
                    value={prefs.weeklySpendingDigestHour || 9}
                    onChange={(e) => handleSavePrefs({ ...prefs, weeklySpendingDigestHour: parseInt(e.target.value) })}
                    style={{ marginLeft: 28, marginTop: 4, background: '#1a1b23', color: '#e4e4e7', border: '1px solid #3a3b45', borderRadius: 6, padding: '4px 8px', fontSize: 13 }}
                  >
                    {Array.from({ length: 24 }, (_, i) => (
                      <option key={i} value={i}>
                        {i === 0 ? '12 AM' : i < 12 ? `${i} AM` : i === 12 ? '12 PM' : `${i - 12} PM`}
                      </option>
                    ))}
                  </select>
                )}
              </div>
              <div className="notif-toggle-row">
                <label className="settings-toggle-label">
                  <input type="checkbox" checked={prefs.netWorthSummary} onChange={() => togglePref('netWorthSummary')} />
                  <span>Daily net worth summary to Tim</span>
                </label>
                {prefs.netWorthSummary && (
                  <select
                    value={prefs.netWorthSummaryHour || 9}
                    onChange={(e) => handleSavePrefs({ ...prefs, netWorthSummaryHour: parseInt(e.target.value) })}
                    style={{ marginLeft: 28, marginTop: 4, background: '#1a1b23', color: '#e4e4e7', border: '1px solid #3a3b45', borderRadius: 6, padding: '4px 8px', fontSize: 13 }}
                  >
                    {Array.from({ length: 24 }, (_, i) => (
                      <option key={i} value={i}>
                        {i === 0 ? '12 AM' : i < 12 ? `${i} AM` : i === 12 ? '12 PM' : `${i - 12} PM`}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              <div className="notif-recipients">
                <h3>Recipients</h3>
                {status.recipients.map((r) => (
                  <div key={r.name} className="notif-recipient-row" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span className="notif-recipient-name">{r.name}</span>
                    <input
                      type="tel"
                      value={(prefs.recipientNumbers && prefs.recipientNumbers[r.name]) || r.number}
                      onChange={(e) => handleSavePrefs({
                        ...prefs,
                        recipientNumbers: { ...prefs.recipientNumbers, [r.name]: e.target.value },
                      })}
                      style={{ flex: 1, minWidth: 120, background: '#1a1b23', color: '#e4e4e7', border: '1px solid #3a3b45', borderRadius: 6, padding: '4px 8px', fontSize: 13 }}
                    />
                    <select
                      value={(prefs.recipientChannels && prefs.recipientChannels[r.name]) || 'whatsapp'}
                      onChange={(e) => handleSavePrefs({
                        ...prefs,
                        recipientChannels: { ...prefs.recipientChannels, [r.name]: e.target.value },
                      })}
                      style={{ background: '#1a1b23', color: '#e4e4e7', border: '1px solid #3a3b45', borderRadius: 6, padding: '4px 8px', fontSize: 13 }}
                    >
                      <option value="sms">SMS</option>
                      <option value="whatsapp">WhatsApp</option>
                    </select>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}

      {status.configured && (
        <div className="notif-test">
          <h3>Send Test Message</h3>
          <form onSubmit={handleSendTest} className="notif-test-form">
            <select value={testChannel} onChange={(e) => setTestChannel(e.target.value)}>
              <option value="sms">SMS</option>
              <option value="whatsapp">WhatsApp</option>
            </select>
            <select value={testTo} onChange={(e) => setTestTo(e.target.value)} required>
              <option value="">Select recipient...</option>
              {status.recipients.map((r) => (
                <option key={r.name} value={r.number}>{r.name} ({r.number})</option>
              ))}
            </select>
            <input
              type="text"
              value={testMsg}
              onChange={(e) => setTestMsg(e.target.value)}
              placeholder="Test message..."
              required
            />
            <button type="submit" className="manage-btn" disabled={sending || !testTo || !testMsg}>
              {sending ? 'Sending...' : `Send ${testChannel === 'whatsapp' ? 'WhatsApp' : 'SMS'}`}
            </button>
            {sendResult && (
              <span className={`notif-result${sendResult === 'Sent!' ? ' success' : ' error'}`}>
                {sendResult}
              </span>
            )}
          </form>
        </div>
      )}
    </section>
  );
}

export default NotificationsPanel;
